import React, { useEffect, useState } from 'react';

const PERSON_GLYPH = (
    <>
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
    </>
);

// Storefront, for the shop portal's shop photo.
export const SHOP_GLYPH = (
    <>
        <path d="M3 9 5 3h14l2 6" />
        <path d="M4 9h16v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z" />
        <path d="M9 22V12h6v10" />
    </>
);

// Circular avatar: the uploaded picture when there is one, otherwise a glyph (a person by
// default, a storefront for shops) on the Kirusa red brand background.
const DriverAvatar = ({ src = '', className = 'h-8 w-8', iconSize = 15, strokeWidth = 2.5, alt = 'Profile picture', onLoadError, glyph = PERSON_GLYPH, children }) => {
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        setFailed(false);
    }, [src]);

    const showImage = Boolean(src) && !failed;

    return (
        <div className={`relative flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-gradient-to-br from-[#E8353C] to-[#B8181E] text-white shadow-[0_4px_12px_rgba(216,31,38,0.25)] ${className}`}>
            {showImage ? (
                <img
                    src={src}
                    alt={alt}
                    className="h-full w-full object-cover"
                    onError={() => {
                        setFailed(true);
                        if (onLoadError) onLoadError();
                    }}
                    draggable={false}
                />
            ) : (
                <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className="drop-shadow-sm" aria-hidden="true">
                    {glyph}
                </svg>
            )}
            {children}
        </div>
    );
};

export default DriverAvatar;
